<p style="text-align: center;">Reports are currently not implemented.</p>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/reports/report-listing/report-listing.component.html